// extracted by mini-css-extract-plugin
module.exports = {"title":"_38QoZ","inner-Wrapper":"_18IdG","innerWrapper":"_18IdG","full-width-button":"JZT8_","fullWidthButton":"JZT8_"};